module.exports = __webpack_public_path__ + "img/ladrillos-alternativo.2f8073da.jpg";